<article>
  <section>
    <div class="tabview-list">
      <div [class.active]="tabIndex === 0" (click)="tabIndex = 0; handleTabChange(0)">
        <span><i class="mdi mdi-format-list-text heading"></i> <span class="isDesktop">&nbsp;List</span></span>
      </div>
      <div [class.active]="tabIndex === 1" (click)="tabIndex = 1; handleTabChange(1)">
        <span><i class="mdi mdi-wrench-outline heading"></i> <span class="isDesktop">&nbsp;Admin</span></span>
      </div>
      <div></div>
    </div>
    <div class="tabview-content">
      @switch (tabIndex) {
        @case (1) {
          @if (can.admin) {
            <app-occupancy-admin></app-occupancy-admin>
          } @else {
            <p>No access</p>
          }
        }
        @default {
          @if (can.list) {
            <app-occupancy-list></app-occupancy-list>
          } @else {
            <p>No access</p>
          }
        }
      }
    </div>
  </section>
</article>
